import { InvoicePaymentApiModel, InvoicePaymentCollection, InvoicePaymentModel, PartialInvoicePaymentCollection, ValidateInvoicePayment } from "@auer-steel/Services/InvoicePaymentService";
import isNumeric from "@insite/client-framework/Common/isNumeric";
import translate from "@insite/client-framework/Translate";

const isNonEmptyString = (value: string | undefined) => value !== undefined && value.trim() !== "";

const isMonthAndYearBeforeToday = (month: number, year: number) => {
    const today = new Date();
    const currentMonth = today.getMonth();
    const currentYear = today.getFullYear();
    return year < currentYear || (year === currentYear && month < currentMonth + 1);
};

export const validateSubmission = async (
    invoicePaymentCollection: InvoicePaymentCollection,
): Promise<InvoicePaymentCollection | undefined> => {
    const validationParameter = convertToApiParameter(invoicePaymentCollection);
    const validationResult = await ValidateInvoicePayment(validationParameter);
    if (!validationResult.isValid) {
        return {
            ...invoicePaymentCollection,
            overviewErrorMessage: validationResult.validationMessage
        };
    }
};

export const convertToApiParameter = (invoiceCollectionModel: InvoicePaymentCollection, partialInvoicePaymentCollection?: PartialInvoicePaymentCollection[]) => {
    const apiParameter: InvoicePaymentApiModel = {
        SelectedInvoice: invoiceCollectionModel.invoicePayments.map(invoicePayment => {
            return {
                InvoiceNumber: invoicePayment.invoice.invoiceNumber,
                PaymentAmount: invoicePayment.paymentAmount };
        }),
        AchAccountId: invoiceCollectionModel.achAccountId,
        PaymentInformation: invoiceCollectionModel.paymentInformation,
        PartialInvoicePaymentCollection: partialInvoicePaymentCollection?.map(partialInvoicePaymentCollection => {
            return {
                InvoiceNumber: partialInvoicePaymentCollection.InvoiceNumber,
                Reason: partialInvoicePaymentCollection.Reason };
        }) ?? []
    };
    return apiParameter;
}

export const getInvoicePaymentDiscountAmount = (invoice: InvoicePaymentModel) => {
    if (invoice.paymentAmount === invoice.invoice.currentBalance  || invoice.payInFull) {
        const termsAmount = invoice.invoice.properties["termsAmount"]?.replace('$','').replace(',','');
        if (isNumeric(termsAmount)) {
            return +termsAmount;
        }
    }
    return 0;
}